const locale = {
  placeholder: 'Selecteer tijd',
}

export default locale



// WEBPACK FOOTER //
// ./components/time-picker/locale/nl_BE.js